import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { getConfig } from '@local/app-config';
import { logUnknownException, Severity } from '@local/error-logging';
import { useEffect, useState } from 'react';
import { initializeMetrics } from './metrics';
import TraceProvider from './TraceProvider';
export const MetricsWrapper = ({ children, datadogConfig, segmentWriteKey, openTelemetryConfig, }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const appConfig = getConfig();
    const metricsConfig = {
        segmentWriteKey,
        env: appConfig === null || appConfig === void 0 ? void 0 : appConfig.environment,
        datadogConfig,
    };
    useEffect(() => {
        const initialize = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!isInitialized) {
                try {
                    yield initializeMetrics(metricsConfig);
                }
                catch (error) {
                    logUnknownException(error, Severity.Error);
                }
                setIsInitialized(true);
            }
        });
        initialize();
    }, [metricsConfig]);
    if (openTelemetryConfig && isInitialized) {
        return _jsx(TraceProvider, { openTelemetryConfig: openTelemetryConfig, children: children });
    }
    return isInitialized ? children : null;
};
//# sourceMappingURL=MetricsWrapper.js.map